import React from "react";
import Hero1 from "../imgs/hero/hero-image1.png";
import Hero2 from "../imgs/hero/hero-image2.png";
import { useNavigate } from "react-router-dom";

const Hero = () => {
  const navigate = useNavigate();

  return (
    <div className="max-w-7xl mx-auto px-1 md:px-6 lg:px-8 flex justify-between items-center relative pt-20">
      <img
        src={Hero1}
        className="hidden lg:flex absolute left-2 left-img"
        height={130}
        width={130}
      />
      <img
        src={Hero2}
        className="hidden lg:flex absolute right-2 right-img"
        height={130}
        width={130}
      />

      <div className="max-w-4xl mx-auto px-4 sm:px-12 lg:px-16 flex flex-col items-center justify-center space-y-6">
        <h1 className="text-black font-black text-3xl lg:text-6xl text-center">
          Turn Your Knowledge <br />
          Into <span className="font-black text-[#3BF5CA]">Rewards</span>
        </h1>

        <p className="text-center text-gray-700 text-sm lg:text-base hero-txt">
          Our games and challenges are designed for creative arts and tech
          learners, giving you the perfect platform to showcase your skills and
          earn real-world rewards.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center md:space-x-4 space-y-4 md:space-y-0">
          <button className="w-full md:w-auto px-10 py-4 bg-[#3BF5CA] border text-[#052035] border-[#052035]  rounded-md">
            <a href="https://app.hallimo.com/register">Get Started</a>
          </button>
          <button
            onClick={() => navigate("/patrons")}
            className="w-full md:w-auto px-10 py-4 text-[#052035] border border-[#052035] rounded-md"
          >
            Become A Patron
          </button>
        </div>
      </div>
    </div>
  );
};

export default Hero;
